import { useState } from "react";
import { ReactComponent as Eye } from "../assets/icons/Eye.svg";
import ImageModal from "./modal/imageModal";
import { resolveMediaUrl } from "../assets/utils/mediaUrl";
import q from "../styles/components/examQuestion.module.scss";

const ZoomableImage = ({ src, alt = "", wrapClassName = "" }) => {
    const [isOpen, setIsOpen] = useState(false);
    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);

    if (!src) return null;

    const resolvedSrc = resolveMediaUrl(src);

    return (
        <>
            {isOpen && <ImageModal imageURL={resolvedSrc} onConfirm={close} />}
            <div className={`${q.imageFrame} ${wrapClassName}`.trim()}>
                <img
                    src={resolvedSrc}
                    alt={alt}
                    className={q.imageThumb}
                    onClick={open}
                    referrerPolicy="no-referrer"
                />
                <button
                    type="button"
                    className={q.imageZoomBtn}
                    onClick={open}
                    aria-label="بزرگنمایی تصویر"
                    title="بزرگنمایی"
                >
                    <Eye width={18} height={18} />
                </button>
            </div>
        </>
    );
};

export default ZoomableImage;
